<template>
  <div class="multiple-select-choice">
    <van-popover @close="onClosePopover" @open="onOpenPopover" v-model="popup" trigger="click" placement="bottom-start">
      <van-checkbox-group v-model="issue.select">
        <ul class="select-group pt-2">
          <li v-for="item in showItems" :key="item.id" class="select-item" @click="onConfirm(item)">
            <div>
              <van-checkbox shape="square" :name="item.id">
                <span>{{ item.text }}</span>
                <template v-slot:icon="{ checked }">
                  <icon-checkbox :value="checked" />
                </template>
              </van-checkbox>
            </div>
          </li>
          <li v-if="!showItems.length && popup" class="select-item">
            <div>
              <span>暂无数据</span>
            </div>
          </li>
        </ul>
      </van-checkbox-group>
      <template v-slot:reference>
        <van-field
          :readonly="!issue.enableFilter"
          @click.stop="onFocus"
          :placeholder="placeholder"
          right-icon="arrow-down"
          v-model="inputValue"
        />
      </template>
    </van-popover>
    <ul class="mt-2" v-if="otherItems.length">
      <li v-for="item in otherItems" :key="item.id" class="mb-2 last:mb-0">
        <div class="leading-base">
          <span>{{ item.content.text }}</span>
        </div>
        <div>
          <van-field v-model="item.value" placeholder="请输入"></van-field>
        </div>
      </li>
    </ul>

    <div class="vote-answer vote-answering-wrapper" v-if="showVoteProgress && changeExpr">
      <template v-if="voteItems.length">
        <div style="margin-bottom: 12px">
          投票排名
        </div>
      </template>
      <choice-vote-content :items="voteItems" />
      <template v-if="voteItems.length > 5">
        <van-button type="primary" size="small" block @click="onShowMoreRank">查看更多排名</van-button>
      </template>
    </div>
  </div>
</template>

<script>
import IconCheckbox from '@/components/base/IconCheckbox'
import { transformRichText2Text } from 'dygc'
import selectVote from './select-vote'
export default {
  name: 'MultipleSelectChoice',
  components: { IconCheckbox },
  mixins:[selectVote],
  changeExpr: 'changeExpr',
  data() {
    return {
      fieldValue: '',
      popup: false,
      inputValue: ''
    }
  },
  computed: {
    changeExpr() {
      const ids = this.issue.select.slice()
      return this.issue.items
        .filter(i => ids.includes(i.id))
        .map(i => {
          return i.id + '|' + i.value
        })
        .join(',')
    },
    otherItems() {
      const ids = this.issue.select
      return this.issue.items.filter(i => i.is_other_item).filter(i => ids.includes(i.id))
    },
    placeholder() {
      if (this.fieldValue && this.popup) {
        return this.fieldValue
      } else {
        return '请选择'
      }
    },
    items() {
      return this.issue.items.map(item => {
        return {
          text: transformRichText2Text(item.content.richText),
          id: item.id
        }
      })
    },
    showItems() {
      const searchValue = this.inputValue
      return this.items.filter(item => item.text.includes(searchValue))
    }
  },
  methods: {
    onFocus() {
      this.popup = !this.popup
    },
    onOpenPopover() {
      this.inputValue = ''
    },
    onClosePopover() {
      this.inputValue = this.fieldValue
    },
    onCancel() {
      // this.popup = false
    },
    onConfirm(val) {
      // this.issue.select.push(val.id)
      // this.popup = false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.inputValue = this.fieldValue
    })
  },
  watch: {
    'issue.select'(val) {
      let items = this.items.filter(item => val.includes(item.id))
      this.fieldValue = items.map(item => item.text).join(',')
      // this.inputValue = this.fieldValue
      this.$emit('change')
    }
  }
}
</script>
